import classNames from 'classnames';
import { InputHTMLAttributes, forwardRef } from 'react';
import css from './URLInput.module.scss';

export type URLInputProps = InputHTMLAttributes<HTMLInputElement> & {
  status?: string;
  isGenerating?: boolean;
};

export const URLInput = forwardRef<HTMLInputElement, URLInputProps>(
  ({ className, status, isGenerating, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={classNames(
          css.urlInput,
          status && css[`status${status.charAt(0).toUpperCase() + status.slice(1)}`],
          isGenerating && css.generating,
          className,
        )}
        type="text"
        {...props}
      />
    );
  },
);
